<script setup lang="ts">
import Ovoid from '@gouvfr/dsfr/dist/artwork/background/ovoid.svg'
import TechnicalError from '@gouvfr/dsfr/dist/artwork/pictograms/system/technical-error.svg'
import { useRoute, useRouter } from 'vue-router'

import GenericContainer from '@/components/GenericContainer.vue'
import config from '@/config'

const route = useRoute()
const router = useRouter()

if (route.name !== 'not_found') {
  router.push({ name: 'not_found' })
}
</script>

<template>
  <GenericContainer>
    <div
      class="fr-my-7w fr-mt-md-12w fr-mb-md-10w fr-grid-row fr-grid-row--gutters fr-grid-row--middle fr-grid-row--center"
    >
      <div class="fr-py-0 fr-col-12 fr-col-md-6">
        <h1>Page non trouvée</h1>
        <p class="fr-text--sm fr-mb-3w">Erreur 404</p>
        <p class="fr-text--lead fr-mb-3w">
          La page que vous cherchez est introuvable. Excusez-nous pour la gêne
          occasionnée.
        </p>
        <p class="fr-text--sm fr-mb-5w">
          Si vous avez tapé l'adresse web dans le navigateur, vérifiez qu'elle
          est correcte. La page n’est peut-être plus disponible.
          <br />Dans ce cas, pour continuer votre visite vous pouvez consulter
          notre page d’accueil, ou effectuer une recherche avec notre moteur de
          recherche en haut de page. <br />Sinon contactez-nous pour que l’on
          puisse vous rediriger vers la bonne information.
        </p>
        <ul class="fr-btns-group fr-btns-group--inline-md">
          <li>
            <RouterLink :to="{ name: 'home' }" class="fr-btn"
              >Page d'accueil</RouterLink
            >
          </li>
          <li v-if="config.website.contact_email">
            <a
              class="fr-btn fr-btn--secondary"
              :href="`mailto:${config.website.contact_email}`"
            >
              Contactez-nous
            </a>
          </li>
        </ul>
      </div>
      <div
        class="fr-col-12 fr-col-md-3 fr-col-offset-md-1 fr-px-6w fr-px-md-0 fr-py-0"
      >
        <svg
          xmlns="http://www.w3.org/2000/svg"
          class="fr-responsive-img fr-artwork"
          aria-hidden="true"
          width="160"
          height="200"
          viewBox="0 0 160 200"
        >
          <use class="fr-artwork-motif" :href="`${Ovoid}#artwork-motif`"></use>
          <use
            class="fr-artwork-background"
            :href="`${Ovoid}#artwork-background`"
          ></use>
          <g transform="translate(40, 60)">
            <use
              class="fr-artwork-decorative"
              :href="`${TechnicalError}#artwork-decorative`"
            ></use>
            <use
              class="fr-artwork-minor"
              :href="`${TechnicalError}#artwork-minor`"
            ></use>
            <use
              class="fr-artwork-major"
              :href="`${TechnicalError}#artwork-major`"
            ></use>
          </g>
        </svg>
      </div>
    </div>
  </GenericContainer>
</template>
